import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/app/experiment.css';
import NumberFormat from "react-number-format";
import classnames from 'classnames';
import {salesOrderEnquiryPageOrderItemStore} from "../../store/sales/order/item/SalesOrderEnquiryPageOrderItemStore";
import {getSorted} from "../../services/CommonService";
import UserService from "../../services/UserService";
import OrderEnquiryPageOrderItemProductLabelWrapper from "./OrderEnquiryOrderItemProductLabelWrapper";


export default class OrderEnquiryOrderItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sortRequest: {
                key: "",
                direction: false
            }
        };
        this.userService = new UserService();
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(type, param, change) {
        let {sortRequest} = this.state;
        switch (type) {
            case "sortRequest":
                if (change.sorterApplicable) {
                    if (sortRequest.key === change.key) {
                        sortRequest.direction = !sortRequest.direction;
                    } else {
                        sortRequest.key = change.key;
                        sortRequest.direction = false;
                    }
                    this.setState({sortRequest});
                }
        }
    }

    render() {
        let {order, toggleExpandRow, toggleAllRowExpanded, visibleColumnsInOrderItems, currentUser} = this.props;
        let orderItems, store, subTotalAmount, totalDiscountAmount, totalTaxAmount, totalAmount;
        let {sortRequest} = this.state;

        orderItems = getSorted(((order && order.items) || []), sortRequest.key, sortRequest.direction);
        store = salesOrderEnquiryPageOrderItemStore.filter(x => visibleColumnsInOrderItems.includes(x.key));

        this.toggleAllRowExpanded = toggleAllRowExpanded;
        this.toggleExpandRow = toggleExpandRow;

        subTotalAmount = order.subTotalAmount;
        totalDiscountAmount = order.totalDiscountAmount;
        totalTaxAmount = order.totalTaxAmount;
        totalAmount = order.totalAmount;

        return (
            <div>
                <Table responsive striped bordered size={"sm"} hover={true}>
                    <thead className="thead-light">
                    <tr>
                        {(store || []).map((item, index) => {
                            return (
                                <th key={index}
                                    onClick={() => this.handleChange("sortRequest", "key", item)}
                                    colSpan={item.colSpan}
                                    className={item.labelClassName}
                                    style={{minWidth: item.minWidth}}>
                                    {item.renderLabel((orderItems || []), this)}
                                    {
                                        item.sorterApplicable ?
                                            <i className={classnames("fa", "float-right", "pt-1", {
                                                    "fa-sort": (sortRequest.key !== item.key),
                                                    "fa-sort-amount-asc": (sortRequest.key === item.key && sortRequest.direction),
                                                    "fa-sort-amount-desc": (sortRequest.key === item.key && !sortRequest.direction),
                                                }
                                            )} aria-hidden="true"/> : null
                                    }

                                </th>
                            );
                        })}
                    </tr>
                    </thead>
                    {
                        (orderItems || []).map((orderItem, orderItemIndex) => {
                            return <tbody key={orderItemIndex}
                                          style={{backgroundColor: orderItem.isExpandable ? "#b8daff" : "#e6f2ff"}}>
                            <tr>
                                {(store || []).map((column, columnIndex) => {
                                    return (
                                        <td key={columnIndex}
                                            className={column.getValueClassName(orderItemIndex, orderItems, this)}>
                                            {column.render(orderItemIndex, orderItems, this)}
                                        </td>
                                    );
                                })}
                            </tr>
                            {
                                orderItem.isExpanded && orderItem.productLabel
                                    ? <tr>
                                        <td colSpan={store.length} style={{"white-space": "pre"}}>
                                            <OrderEnquiryPageOrderItemProductLabelWrapper orderItem={orderItem}/>
                                        </td>
                                    </tr>
                                    : null
                            }
                            </tbody>
                        })
                    }
                    <tbody>
                    {(order.edi && (!currentUser.isExternalUser))
                        ? <tr>
                            <th colSpan={store.length - 1}>EDI-total</th>
                            <th className={"text-right"}>
                                <NumberFormat
                                    value={order.edI_TotalAmount}
                                    displayType={'text'}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    prefix={'$'}/>
                            </th>
                        </tr>
                        : null
                    }
                    <tr>
                        <th colSpan={store.length - 1}>Sub-total</th>
                        <th className={"text-right"}>
                            <NumberFormat
                                value={subTotalAmount}
                                displayType={'text'}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                prefix={'$'}/>
                        </th>
                    </tr>
                    {
                        (!currentUser.isExternalUser)
                            ? <tr>
                                <th colSpan={store.length - 1}>Discount</th>
                                <th className={"text-right"}>
                                    <NumberFormat
                                        value={totalDiscountAmount}
                                        displayType={'text'}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        prefix={'$'}/>
                                </th>
                            </tr>
                            : null
                    }

                    <tr>
                        <th colSpan={store.length - 1}>GST</th>
                        <th className={"text-right"}>
                            <NumberFormat
                                value={totalTaxAmount}
                                displayType={'text'}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                prefix={'$'}/>
                        </th>
                    </tr>
                    <tr className="bg-white">
                        <th colSpan={store.length - 1}>Order Total</th>
                        <th className={"text-right"}>
                            <NumberFormat
                                value={totalAmount}
                                displayType={'text'}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                prefix={'$'}/>
                        </th>
                    </tr>
                    </tbody>
                </Table>
                <ToastContainer/>
            </div>
        );
    }
};